"use strict";
var _a;
exports.__esModule = true;
exports.ERRORS = exports.ErrorCode = void 0;
var StatusCodeEnum_1 = require("./../../lib/infrastructure/StatusCodeEnum");
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["E001"] = "E001";
    ErrorCode["E002"] = "E002";
    ErrorCode["E003"] = "E003";
    ErrorCode["E004"] = "E004";
    ErrorCode["E005"] = "E005";
    ErrorCode["E006"] = "E006";
    ErrorCode["E007"] = "E007";
    ErrorCode["E008"] = "E008";
    ErrorCode["E009"] = "E009";
    ErrorCode["E010"] = "E010";
    ErrorCode["E011"] = "E011";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
exports.ERRORS = (_a = {},
    _a[ErrorCode.E001] = {
        code: ErrorCode.E001,
        message: "El cuerpo de la petición es inválido.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E002] = {
        code: ErrorCode.E002,
        message: "Ha ocurrido un error inesperado.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.InternalServerError
    },
    _a[ErrorCode.E003] = {
        code: ErrorCode.E003,
        message: "La tarjeta no permite realizar pagos diferidos.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E004] = {
        code: ErrorCode.E004,
        message: "Id de comercio no válido.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E005] = {
        code: ErrorCode.E005,
        message: "El número de tarjeta no es válido.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E006] = {
        code: ErrorCode.E006,
        message: "Error de validación apple pay.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E007] = {
        code: ErrorCode.E007,
        message: "Error al iniciar sesión.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E008] = {
        code: ErrorCode.E008,
        message: "Código incorrecto, ingresar nuevamente.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E009] = {
        code: ErrorCode.E009,
        message: "Error al validar sesión.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E010] = {
        code: ErrorCode.E010,
        message: "Es necesaria la verificación de autenticación del usuario.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a[ErrorCode.E011] = {
        code: ErrorCode.E011,
        message: "Sesión no disponible.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest
    },
    _a);
